/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInnerOccupanciesInner } from './IntegrationEventPccPatientLeadsInnerOccupanciesInner';
import {
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerToJSON,
} from './IntegrationEventPccPatientLeadsInnerOccupanciesInner';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInner
 */
export interface IntegrationEventPccPatientLeadsInner {
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInner
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInner
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInner
     */
    admission_status?: IntegrationEventPccPatientLeadsInnerAdmissionStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof IntegrationEventPccPatientLeadsInner
     */
    admission_status_info?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof IntegrationEventPccPatientLeadsInner
     */
    crmEventLogs?: Array<object>;
    /**
     * 
     * @type {Array<IntegrationEventPccPatientLeadsInnerOccupanciesInner>}
     * @memberof IntegrationEventPccPatientLeadsInner
     */
    occupancies?: Array<IntegrationEventPccPatientLeadsInnerOccupanciesInner>;
}


/**
 * @export
 */
export const IntegrationEventPccPatientLeadsInnerAdmissionStatusEnum = {
    Booked: 'Booked',
    MovedIn: 'Moved-In',
    MovedOut: 'Moved-Out',
    Lost: 'Lost',
    Hospitalized: 'Hospitalized'
} as const;
export type IntegrationEventPccPatientLeadsInnerAdmissionStatusEnum = typeof IntegrationEventPccPatientLeadsInnerAdmissionStatusEnum[keyof typeof IntegrationEventPccPatientLeadsInnerAdmissionStatusEnum];


/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInner interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventPccPatientLeadsInnerFromJSON(json: any): IntegrationEventPccPatientLeadsInner {
    return IntegrationEventPccPatientLeadsInnerFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'admission_status': !exists(json, 'admission_status') ? undefined : json['admission_status'],
        'admission_status_info': !exists(json, 'admission_status_info') ? undefined : json['admission_status_info'],
        'crmEventLogs': !exists(json, 'crmEventLogs') ? undefined : json['crmEventLogs'],
        'occupancies': !exists(json, 'occupancies') ? undefined : ((json['occupancies'] as Array<any>).map(IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSON)),
    };
}

export function IntegrationEventPccPatientLeadsInnerToJSON(value?: IntegrationEventPccPatientLeadsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.first_name,
        'last_name': value.last_name,
        'admission_status': value.admission_status,
        'admission_status_info': value.admission_status_info,
        'crmEventLogs': value.crmEventLogs,
        'occupancies': value.occupancies === undefined ? undefined : ((value.occupancies as Array<any>).map(IntegrationEventPccPatientLeadsInnerOccupanciesInnerToJSON)),
    };
}

